import { MemeGeneratorState, TextBox } from "store/features/memeGenerator/types";
import { useFontList } from "./useFontList";
import { FontSearch } from "./FontSearch/FontSearch";
import { SelectedFont } from "./SelectedFont/SelectedFont";
import { RecentlyUsedFonts } from "./RecentlyUsedFonts/RecentlyUsedFonts";
import { WebFonts } from "./WebFonts/WebFonts";
import { filterWebFonts } from "store/features/memeGenerator/filterWebFonts";
import { GoogleFonts } from "./GooleFonts/GoogleFonts";
import { filterGoogleFonts } from "store/features/memeGenerator/filterGoogleFonts";

interface FontListProps {
    googleFonts: MemeGeneratorState["googleFonts"]["list"];
    loadMoreFonts: () => Promise<void>;
    textBox: TextBox;
    onClose: () => void;
}

export const FontList = ({ googleFonts: _googleFonts, loadMoreFonts, textBox, onClose }: FontListProps) => {
    const {
        handleScroll,
        recentlyUsedFonts,
        isLoadingRecentlyUsedFonts,
        handleClick,
        isLoadingMore,
        webFonts,
        search,
        handleSearch,
        searchedGoogleFonts,
    } = useFontList(textBox, loadMoreFonts, onClose);
    return (
        <div
            className="absolute top-full left-0 mt-2 rounded-xl border border-irGray-200 dark:border-darkSurface-100 py-4 bg-white dark:bg-darkSurface-200 max-h-[80vh] scroll overscroll-none flex flex-col min-w-[360px] text-black dark:text-white"
            onScroll={handleScroll}
        >
            <FontSearch search={search} handleSearch={handleSearch} />
            <SelectedFont fontFamily={textBox.fontFamily} />
            <RecentlyUsedFonts
                recentlyUsedFonts={recentlyUsedFonts}
                isLoadingRecentlyUsedFonts={isLoadingRecentlyUsedFonts}
                search={search}
                handleClick={handleClick}
            />
            <WebFonts
                webFonts={filterWebFonts(webFonts, recentlyUsedFonts, textBox.fontFamily)}
                handleClick={handleClick}
            />
            <GoogleFonts
                googleFonts={filterGoogleFonts({
                    search,
                    searchedGoogleFonts,
                    allGoogleFonts: _googleFonts,
                    recentlyUsedFonts,
                    fontFamily: textBox.fontFamily,
                })}
                handleClick={handleClick}
                isLoadingMore={isLoadingMore}
            />
        </div>
    );
};
